import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/interfaces/user';
import { ErrorService } from 'src/app/services/error.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
  username: string = '';
  password: string = ''; // Campo para la nueva contraseña
  rol: number = 1;
  loading: boolean = false;
  user: any; // Propiedad para almacenar los datos del usuario (puedes cambiar 'any' por el tipo correcto)

  constructor(
    private toastr: ToastrService,
    private _userService: UserService,
    private router: Router,
    private _errorService: ErrorService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {}

  // Método para generar una contraseña aleatoria
  generateRandomPassword() {
    this.password = Math.floor(1000 + Math.random() * 9000).toString(); // Genera una contraseña aleatoria
  }
  resetpassword() {
    // Validamos que el usuario haya ingresado datos
    if (this.username === '') {
      this.toastr.error('El campo usuario es obligatorio', 'Error');
      return;
    }
  
    // Validamos que se haya ingresado una contraseña
    if (this.password === '') {
      this.toastr.error('El campo contraseña es obligatorio', 'Error');
      return;
    }
  
    // Inicializamos el objeto user
    const user: User = {
      username: this.username,
      password: this.password
    };
  
    // Llamamos al servicio para actualizar el nombre de usuario y la contraseña
    this.loading = true;
    this._userService.updateUser(this.username, this.password, user).subscribe({
      next: (response) => {
        this.toastr.success('Contraseña actualizada exitosamente', 'Éxito');
        this.loading = false;
        this.router.navigate(['/login']);
      },
      error: (e: HttpErrorResponse) => {
        this._errorService.msjError(e);
        this.loading = false;
      }
    });
  }
  resetpassword2() {
    // Validamos que el usuario haya ingresado datos
    if (this.username === '') {
      this.toastr.error('El campo usuario es obligatorio', 'Error');
      return;
    }

    // Validamos que se haya ingresado una contraseña
    if (this.password === '') {
      this.toastr.error('El campo contraseña es obligatorio', 'Error');
      return;
    }

    // Llamamos al servicio para actualizar el nombre de usuario y la contraseña
    this.loading = true;
    this._userService.updateUser(this.username, this.password, this.user).subscribe({
      next: () => {
        this.toastr.success('Contraseña actualizada exitosamente', 'Éxito');
        this.loading = false;
        this.router.navigate(['/login']);
      },
      error: (e: HttpErrorResponse) => {
        this._errorService.msjError(e);
        this.loading = false;
      }
    });
  }
}
